import { render, staticRenderFns } from "./MFileItem.vue?vue&type=template&id=053f10a9&scoped=true&"
import script from "./MFileItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MFileItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MFileItem.vue?vue&type=style&index=0&id=053f10a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053f10a9",
  null
  
)

export default component.exports